export default class LookupType {
    constructor (rawData = {}) {
        this.id = rawData.id;
        this.type = rawData.type;
    }
}